/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const zh_hans1_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟随系统`)
};

const zh_hant1_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟隨系統`)
};

const fr_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Système`)
};

const de_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const ja_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム`)
};

const ko_theme_system = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시스템`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const theme_system = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.theme_system(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("theme_system", locale)
	if (locale === "en") return en_theme_system(inputs)
	if (locale === "zh-Hans") return zh_hans1_theme_system(inputs)
	if (locale === "zh-Hant") return zh_hant1_theme_system(inputs)
	if (locale === "fr") return fr_theme_system(inputs)
	if (locale === "de") return de_theme_system(inputs)
	if (locale === "ja") return ja_theme_system(inputs)
	return ko_theme_system(inputs)
};